import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from '../../system';
import { Children, forwardRef, useMemo } from 'react';
import { DotIcon } from '../../Icons';
export const Badge = forwardRef(({ icon, iconCSS, leftIcon, leftIconCSS, rightIcon, rightIconCSS, dot, children, ...props }, ref) => {
    const hasIcon = useMemo(() => Boolean(icon), [icon]);
    const hasLeftIcon = useMemo(() => Boolean(leftIcon), [leftIcon]);
    const hasRightIcon = useMemo(() => Boolean(rightIcon), [rightIcon]);
    return (_jsx(StyledBadge, { ref: ref, ...props, hasIcon: hasIcon, hasLeftIcon: hasLeftIcon || dot, hasRightIcon: hasRightIcon, children: Children.count(children) === 0 ? (hasIcon && (_jsx(StyledBadgeIcon, { css: iconCSS, position: "center", size: props.size, children: icon }))) : (_jsxs(_Fragment, { children: [dot && (_jsx(StyledBadgeIcon, { css: leftIconCSS, position: "left", size: props.size, children: _jsx(DotIcon, {}) })), hasLeftIcon && (_jsx(StyledBadgeIcon, { css: leftIconCSS, position: "left", size: props.size, children: leftIcon })), _jsx("span", { children: children }), hasRightIcon && (_jsx(StyledBadgeIcon, { css: rightIconCSS, position: "right", size: props.size, children: rightIcon }))] })) }));
});
const StyledBadge = styled('span', {
    rounded: '$full',
    fontWeight: '$medium',
    flexCenter: true,
    noWrap: true,
    d: 'inline-flex',
    gap: '$1dot5',
    variants: {
        size: {
            sm: {
                textXs: true,
                lineHeight: '$none',
                minMaxH: 22,
                px: '$2'
            },
            md: {
                textSm: true,
                lineHeight: '$none',
                minMaxH: 24,
                px: '$2dot5'
            },
            lg: {
                textSm: true,
                lineHeight: '$none',
                minMaxH: 28,
                px: '$3'
            }
        },
        variant: {
            neutral: {
                bgColor: '$badgeNeutralBg',
                color: '$badgeNeutralText'
            },
            primary: {
                bgColor: '$badgePrimaryBg',
                color: '$badgePrimaryText'
            },
            danger: {
                bgColor: '$badgeDangerBg',
                color: '$badgeDangerText'
            },
            warning: {
                bgColor: '$badgeWarningBg',
                color: '$badgeWarningText'
            },
            success: {
                bgColor: '$badgeSuccessBg',
                color: '$badgeSuccessText'
            }
        },
        hasLeftIcon: {
            true: {
                gap: 0,
                pl: 0
            }
        },
        hasIcon: {
            true: {
                gap: 0,
                px: 0
            }
        },
        hasRightIcon: {
            true: {
                gap: 0,
                pr: 0
            }
        }
    },
    defaultVariants: {
        size: 'sm',
        variant: 'neutral'
    }
});
const StyledBadgeIcon = styled('span', {
    flexCenter: true,
    rounded: '$full',
    variants: {
        size: {
            sm: {
                minMaxSize: 22
            },
            md: {
                minMaxSize: 24
            },
            lg: {
                minMaxSize: 28
            }
        },
        position: {
            center: {},
            left: {},
            right: {}
        }
    },
    defaultVariants: {
        size: 'sm'
    }
});
Badge.toString = StyledBadge.toString;
Badge.displayName = 'Badge';
